import { render } from "./how-it-works.vue?vue&type=template&id=3ed3f352&ts=true"
import script from "./how-it-works.vue?vue&type=script&lang=ts"
export * from "./how-it-works.vue?vue&type=script&lang=ts"

import "./how-it-works.vue?vue&type=style&index=0&id=3ed3f352&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__